import { transformToLoketEmployment } from '@/entities/LoketEmployment/LoketEmploymentTransformers'

import { YearEndStatement, YearEndStatementResource } from './YearEndStatement'

export const transformToYearEndStatement = (resource: YearEndStatementResource): YearEndStatement => ({
    year: resource.year,
    employment: transformToLoketEmployment(resource.employment),
})
